var map = {
	"./ai-conversation/chat": "469c",
	"./ai-conversation/chat.vue": "469c",
	"./ai-conversation/conversationDemo": "1f76",
	"./ai-conversation/conversationDemo.vue": "1f76",
	"./ai-conversation/lineChart": "fccc",
	"./ai-conversation/lineChart.js": "fccc",
	"./airbnb": "413b",
	"./airbnb.vue": "413b",
	"./ait": "d0cb",
	"./ait.vue": "d0cb",
	"./allqrcodes": "fd2c",
	"./allqrcodes.vue": "fd2c",
	"./appointment/appointment": "68cb",
	"./appointment/appointment.vue": "68cb",
	"./broadcastDemo": "b334",
	"./broadcastDemo.vue": "b334",
	"./ciph": "8bdc",
	"./ciph.js": "8bdc",
	"./ciph.json": "3347",
	"./countries": "d1c3",
	"./countries.json": "d1c3",
	"./courier/conversations": "ca9a",
	"./courier/conversations.vue": "ca9a",
	"./courier/directionsRenderer": "d7db",
	"./courier/directionsRenderer.js": "d7db",
	"./courier/dispatcher": "4e91",
	"./courier/dispatcher.vue": "4e91",
	"./courier/lineChart": "994f",
	"./courier/lineChart.js": "994f",
	"./courier/localization": "e6d1",
	"./courier/localization.vue": "e6d1",
	"./deepfake": "76a4",
	"./deepfake.vue": "76a4",
	"./dhmedical": "310e",
	"./dhmedical.vue": "310e",
	"./diarization/Publisher": "c2e6",
	"./diarization/Publisher.vue": "c2e6",
	"./diarization/Session": "51fb",
	"./diarization/Session.vue": "51fb",
	"./diarization/Subscriber": "da21",
	"./diarization/Subscriber.vue": "da21",
	"./diarization/chat": "adca",
	"./diarization/chat.vue": "adca",
	"./diarization/diarization": "bf9b",
	"./diarization/diarization.vue": "bf9b",
	"./events": "80ac",
	"./events.vue": "80ac",
	"./faceID": "441b",
	"./faceID.vue": "441b",
	"./gVerify": "64eb",
	"./gVerify.vue": "64eb",
	"./gameDemo": "173b",
	"./gameDemo.vue": "173b",
	"./genericDemo": "6fc4",
	"./genericDemo.vue": "6fc4",
	"./google/chat": "8627",
	"./google/chat.vue": "8627",
	"./google/lineChart": "95f3",
	"./google/lineChart.js": "95f3",
	"./google/sentimentDemo": "d120",
	"./google/sentimentDemo.vue": "d120",
	"./hackDemo": "1ca9",
	"./hackDemo.vue": "1ca9",
	"./inapp": "819d",
	"./inapp.vue": "819d",
	"./inappDemo/demo": "71db",
	"./inappDemo/demo.vue": "71db",
	"./inappDemo/guide": "e822",
	"./inappDemo/guide.vue": "e822",
	"./inappDemo/inappDemo": "9ffe",
	"./inappDemo/inappDemo.vue": "9ffe",
	"./inappDemo/sections/description": "85b2",
	"./inappDemo/sections/description.vue": "85b2",
	"./inappDemo/sections/login/firstTime": "12e6",
	"./inappDemo/sections/login/firstTime.vue": "12e6",
	"./inappDemo/sections/login/login": "66de",
	"./inappDemo/sections/login/login.vue": "66de",
	"./inappDemo/sections/login/loginPage": "b4be",
	"./inappDemo/sections/login/loginPage.vue": "b4be",
	"./inappDemo/sections/pushNotification": "2305",
	"./inappDemo/sections/pushNotification.vue": "2305",
	"./inappDemo/sections/setup/setup": "daab",
	"./inappDemo/sections/setup/setup.vue": "daab",
	"./inappDemo/sections/sip": "57dc",
	"./inappDemo/sections/sip.vue": "57dc",
	"./inappDemo/sections/usage/chat": "6127",
	"./inappDemo/sections/usage/chat.vue": "6127",
	"./inappDemo/sections/usage/main": "a32e",
	"./inappDemo/sections/usage/main.vue": "a32e",
	"./inappDemo/sections/usage/newConversation": "9291",
	"./inappDemo/sections/usage/newConversation.vue": "9291",
	"./inappDemo/sections/usage/usage": "6c42",
	"./inappDemo/sections/usage/usage.vue": "6c42",
	"./insightDemo": "a24a",
	"./insightDemo.vue": "a24a",
	"./lex/cci": "b790",
	"./lex/cci.vue": "b790",
	"./lex/chat": "75a6",
	"./lex/chat.vue": "75a6",
	"./lex/lexDemo": "c672",
	"./lex/lexDemo.vue": "c672",
	"./lex/lineChart": "f406",
	"./lex/lineChart.js": "f406",
	"./lex/qrcodes": "dbb9",
	"./lex/qrcodes.vue": "dbb9",
	"./meetings2": "a56b",
	"./meetings2.vue": "a56b",
	"./mms": "8a31",
	"./mms.vue": "8a31",
	"./moderation": "d821",
	"./moderation.vue": "d821",
	"./njordr/avatar-f-1.png": "2267",
	"./njordr/bankfraud": "e137",
	"./njordr/bankfraud.vue": "e137",
	"./njordr/branded": "d224",
	"./njordr/branded.vue": "d224",
	"./njordr/graph-1.png": "fd05",
	"./njordr/graph-2.png": "27cb",
	"./njordr/graph-3.png": "972c",
	"./njordr/hero-homepage-02.jpg": "2016",
	"./njordr/njordr": "34cc",
	"./njordr/njordr.png": "9f7a",
	"./njordr/njordr.vue": "34cc",
	"./nova": "5387",
	"./nova.vue": "5387",
	"./novavideo/Publisher": "c2f8",
	"./novavideo/Publisher.vue": "c2f8",
	"./novavideo/Session": "2b4d",
	"./novavideo/Session.vue": "2b4d",
	"./novavideo/Subscriber": "3fc2",
	"./novavideo/Subscriber.vue": "3fc2",
	"./novavideo/chat": "1e16",
	"./novavideo/chat.vue": "1e16",
	"./novavideo/novavideo": "fee6",
	"./novavideo/novavideo.vue": "fee6",
	"./nvstats": "de11",
	"./nvstats.vue": "de11",
	"./opentokDemo/Publisher": "60f9",
	"./opentokDemo/Publisher.vue": "60f9",
	"./opentokDemo/Session": "d0d0",
	"./opentokDemo/Session.vue": "d0d0",
	"./opentokDemo/Subscriber": "9182",
	"./opentokDemo/Subscriber.vue": "9182",
	"./opentokDemo/opentokDemo": "5def",
	"./opentokDemo/opentokDemo.vue": "5def",
	"./parallelTranscription": "72d8",
	"./parallelTranscription.vue": "72d8",
	"./payment": "98c9",
	"./payment.vue": "98c9",
	"./polling": "ac9c",
	"./polling.vue": "ac9c",
	"./questions": "2fec",
	"./questions.vue": "2fec",
	"./rainbowPOS": "629b",
	"./rainbowPOS.vue": "629b",
	"./rcsvoice": "c0f1",
	"./rcsvoice.vue": "c0f1",
	"./recall": "5fda",
	"./recall.vue": "5fda",
	"./recognitionDemo": "a7bc",
	"./recognitionDemo.vue": "a7bc",
	"./rtiViberDemo": "ffa8",
	"./rtiViberDemo.vue": "ffa8",
	"./silent": "4a54",
	"./silent.vue": "4a54",
	"./smsDemo": "75ff",
	"./smsDemo.vue": "75ff",
	"./socialsDemo": "8641",
	"./socialsDemo.vue": "8641",
	"./starwars/chat": "a360",
	"./starwars/chat.vue": "a360",
	"./starwars/intro": "bbc8",
	"./starwars/intro.vue": "bbc8",
	"./starwars/lineChart": "50eb",
	"./starwars/lineChart.js": "50eb",
	"./starwars/ships": "dd0d",
	"./starwars/ships.vue": "dd0d",
	"./starwars/swBot": "2213",
	"./starwars/swBot.vue": "2213",
	"./starwars/swDesigner": "e9ac",
	"./starwars/swDesigner.vue": "e9ac",
	"./starwars/swSupport": "f0ed",
	"./starwars/swSupport.vue": "f0ed",
	"./starwars/swVerify": "e056",
	"./starwars/swVerify.vue": "e056",
	"./tileqr": "dec8",
	"./tileqr.vue": "dec8",
	"./translation": "a7fa",
	"./translation.vue": "a7fa",
	"./unifiedAgentDemo": "c4d7",
	"./unifiedAgentDemo.vue": "c4d7",
	"./v4v": "adcd",
	"./v4v.vue": "adcd",
	"./vault": "c045",
	"./vault.vue": "c045",
	"./vera": "1c0e",
	"./vera.vue": "1c0e",
	"./verifyDemo": "26d2",
	"./verifyDemo.vue": "26d2",
	"./verimetrics": "b085",
	"./verimetrics.vue": "b085",
	"./vfraud": "d461",
	"./vfraud.vue": "d461",
	"./viber": "7640",
	"./viber.vue": "7640",
	"./videoExpress": "db3b",
	"./videoExpress.vue": "db3b",
	"./videoGuest": "41c1",
	"./videoGuest.vue": "41c1",
	"./vidsy2": "7727",
	"./vidsy2.vue": "7727",
	"./voiceDemo": "8a0f",
	"./voiceDemo.vue": "8a0f",
	"./voiceToAzureBot": "f0d4",
	"./voiceToAzureBot.vue": "f0d4",
	"./vonito": "535a",
	"./vonito.vue": "535a",
	"./waotp": "1e01",
	"./waotp.vue": "1e01",
	"./waotptab": "307d",
	"./waotptab.vue": "307d",
	"./whisprDemo": "0ab3",
	"./whisprDemo.vue": "0ab3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c87c";